// Organizing Committee data for Global Azure 2026
export interface CommitteeMember {
  id: string;
  fullName: string;
  role: string;
  profilePicture: string;
}

export const organizingCommittee: CommitteeMember[] = [
    {
      id: "1",
      fullName: "Pathum Udana",
      role: "Community Manager",
      profilePicture: "/assets/img/organizing-committee/pathum.jpeg",
    },
  {
    id: "2",
    fullName: "Prishan Perera",
    role: "Community Manager",
    profilePicture: "/assets/img/organizing-committee/prishan.jpeg",
  },
  {
    id: "3",
    fullName: "Samitha Dasun Peiris",
    role: "Community Manager",
    profilePicture: "/assets/img/organizing-committee/samith.jpeg",
  },
  {
    id: "4",
    fullName: "Anusarani Gunawardana",
    role: "Community Organizer",
    profilePicture: "/assets/img/organizing-committee/anu.jpeg",
  },

  {
    id: "5",
    fullName: "Dineth Siriwardana",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/dineth.jpeg",
  },

  {
    id: "6",
    fullName: "Himasha Gimhani",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/himasha.jpeg",
  },
  {
    id: "7",
    fullName: "Thisara Perera",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/thisara.jpeg",
  },
  {
    id: "8",
    fullName: "Hasitha Sandeepa",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/hasitha.jpeg",
  },
  {
    id: "9",
    fullName: "Kavindu Umayanga",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/kavindu.jpeg",
  },
  {
    id: "10",
    fullName: "Dilan Ranasinghe",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/dilan.jpeg",
  },
  {
    id: "11",
    fullName: "Roshan Lakmal",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/roshan.jpeg",
  },

    {
    id: "12",
    fullName: "Sanduni Ranasinghe",
    role: "Community Lead",
    profilePicture: "/assets/img/organizing-committee/sandunir.jpeg",
  },
    {
    id: "13",
    fullName: "Ashan Silva",
    role: "Event Coordinator",
    profilePicture: "/assets/img/organizing-committee/ashan.jpeg",
  },
  {
    id: "14",
    fullName: "Sanduni Rupasinghe",
    role: "Event Coordinator",
    profilePicture: "/assets/img/organizing-committee/sanduni.jpeg",
  },
    {
    id: "15",
    fullName: "Dewmini Kavinya",
    role: "Event Coordinator",
    profilePicture: "/assets/img/organizing-committee/dewmini.jpeg",
  }
];
